import React, { useState } from "react";

export default function Cta() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail("");
      setTimeout(() => setSubmitted(false), 4000);
    }
  };

  return (
    <section className="relative py-24 lg:py-32 bg-gray-900 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#0186ef]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:4rem_4rem]" />
      </div>

      <div className="relative max-w-3xl mx-auto px-6 lg:px-16 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/10 rounded-full mb-8 backdrop-blur-sm">
          <div className="w-1.5 h-1.5 rounded-full bg-[#0186ef]" />
          <span className="text-xs font-semibold text-blue-300 uppercase tracking-wider">Stay Updated</span>
        </div>

        <h2 className="text-4xl sm:text-5xl font-bold text-white leading-tight mb-4">
          Subscribe to our newsletter
        </h2>
        <p className="text-lg text-gray-400 max-w-xl mx-auto mb-10">
          Get insights on our latest products, industry trends, and company updates delivered to your inbox.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="flex-1 rounded-xl h-12 px-5 text-sm text-gray-900 bg-white border-0 focus:outline-none focus:ring-2 focus:ring-[#0186ef] placeholder:text-gray-400"
          />
          <button
            type="submit"
            className="inline-flex items-center justify-center h-12 px-6 text-sm font-semibold text-white bg-[#0186ef] rounded-xl hover:bg-[#0070d0] transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/25 whitespace-nowrap"
          >
            Subscribe
          </button>
        </form>

        {submitted && (
          <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-green-500/10 text-green-400 rounded-full text-sm font-medium">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            Thank you for subscribing!
          </div>
        )}

        <p className="mt-4 text-xs text-gray-500">No spam, ever. Unsubscribe at any time.</p>
      </div>
    </section>
  );
}
